import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header\"><div class=\"card-title\"><h2 class=\"fw-bolder\">Products</h2></div><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-light-primary\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_add_product\"> Add Product </button></div></div>", 1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4",
  id: "kt_subscription_products_table"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-300px" }, "Product"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px text-end" }, "Remove")
  ])
], -1)
const _hoisted_7 = { class: "text-gray-600" }
const _hoisted_8 = { class: "odd" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Beginner Plan", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "149.99 / Month", -1)
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = {
  href: "#",
  class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-action": "product_remove",
  "data-bs-original-title": "Delete"
}
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = { class: "even" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "Pro Plan", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "1", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "499.99 / Month", -1)
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = {
  href: "#",
  class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-action": "product_remove",
  "data-bs-original-title": "Delete"
}
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = { class: "odd" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Team Plan", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "1", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "999.99 / Month", -1)
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = {
  href: "#",
  class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-action": "product_remove",
  "data-bs-original-title": "Delete"
}
const _hoisted_28 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", _hoisted_7, [
            _createElementVNode("tr", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("a", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_22, [
              _hoisted_23,
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("td", _hoisted_26, [
                _createElementVNode("a", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}